import "./Success.scss";

function Success() {
  return(
    <div class="success">
      <h1>Success!</h1>
      <p>Your submission was successful</p>
    </div>
  )
}

export default Success;